import { render, staticRenderFns } from "./PromptPayTables.vue?vue&type=template&id=0ca4365f&scoped=true&"
import script from "./PromptPayTables.vue?vue&type=script&lang=js&"
export * from "./PromptPayTables.vue?vue&type=script&lang=js&"
import style0 from "./PromptPayTables.vue?vue&type=style&index=0&id=0ca4365f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4365f",
  null
  
)

export default component.exports